import { Http } from '../utils/Http'
import { ISubClass } from '../utils/ISubClass'
import { SerializationHelper } from '../utils/SerializationHelper'
import { StringUtils } from '../utils/StringUtils'
import { AbstractModel } from './AbstractModel'

export class ShopDonate extends AbstractModel {
    id = 0;
    appId: number | null = null;
    name: string | null = null;
    paypalEmail: string | null = null;
    priceDefault: number | null = null;
    priceItem: number | null = null;
    priceFull: number | null = null;
    image: string | null = null;
    description: string | null = null;
    payments: number | null = null;
    dateCreate: string | null = null;
    moreInfoLink: string | null = null;
    active: boolean | null = null;
    birthdayRequired = false;

    public static async getAll<T extends AbstractModel> (this: new() => T, { params, subclasses }: { params?: Array<string | number>; subclasses?: ISubClass[] }): Promise<any> {
      const res = await Http.request('/api/shop-donate')
      const data = await res.json()
      const activeDonates = SerializationHelper.toInstanceArray(ShopDonate, data.active)
      const inactiveDonates = SerializationHelper.toInstanceArray(ShopDonate, data.inactive)
      return [...activeDonates, ...inactiveDonates]
    }

    get priceFullMoneyString () {
      if (this.priceFull) {
        return StringUtils.toMoneyString(this.priceFull)
      } else {
        return ''
      }
    }
}
